import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import { Field, reduxForm } from 'redux-form';
import './AddMaterialsForm.css';
import FormInput from 'components/shared/form/FormInput';
import FormTextArea from 'components/shared/form/FormTextArea';
import FormDropDown from 'components/shared/form/FormDropDown';
import FormDocument from 'components/shared/form/FormDocument';

class AddMaterialsForm extends Component {
  renderImage = (props) => {
    let images = [];
    if (props.input.value) {
      if (typeof props.input.value === 'object') {
        if (props.input.value.hasOwnProperty('url')) {
          images.push({
            url: props.input.value.url,
            preview: props.input.value.preview.url,
          });
        } else {
          images.push({
            url: URL.createObjectURL(props.input.value),
          });
        }
      }
    }
    return (
      <ImageUpload
        extensions={['.jpg', '.jpeg', '.gif', '.png']}
        images={images}
        readOnly={false}
        onRemove={() => props.input.onChange('')}
        onUpload={(files) => props.input.onChange(files[0])}
      />
    );
  };

  render() {
    const edit = this.props.initialValues !== null;
    return (
      <div className="add-materials-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Task
            </Col>
            <Col sm={9}>
              <Field
                component={FormDropDown}
                disabled={edit}
                name="taskId"
                options={this.props.tasks.map((task) => ({
                  value: task.id,
                  label: `${task.number} - ${task.name}`,
                }))}
                placeholder="Task"
              />
            </Col>
          </FormGroup>
          <div className="files-comment">
            Please upload at least one image and/or one document.
          </div>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Photo
            </Col>
            <Col sm={9}>
              <Field
                component={this.renderImage}
                name="image"
                placeholder="Photo"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Document
            </Col>
            <Col sm={9}>
              <Field
                component={FormDocument}
                name="document"
                placeholder="Document"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Amount
            </Col>
            <Col sm={9}>
              <Field
                component={FormInput}
                name="cost"
                placeholder="Amount"
                type="number"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Description
            </Col>
            <Col sm={9}>
              <Field
                component={FormTextArea}
                name="description"
                placeholder="Description"
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to add materials.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value={edit ? 'Update' : 'Create'}
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.taskId) {
    errors.taskId = 'Required';
  }
  if (!values.cost) {
    errors.cost = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.image && !values.document) {
    errors.image = 'Required';
    errors.document = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'AddMaterialsForm',
  validate,
})(AddMaterialsForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/receipts/AddMaterialsForm.js